import type { Item } from '../schemas/item';

export function isLowStock(item: Item): boolean {
  return item.min_quantity != null && item.quantity < item.min_quantity;
}
